import React from 'react'
import Logo from './Logo'

interface PageLoaderProps {
  /**
   * fullscreen: fallback de rota (fundo próprio + logo + texto).
   * inline: fallback dentro de um shell já visível (só o spinner).
   */
  variant?: 'fullscreen' | 'inline'
}

// Fallback de Suspense para rotas lazy. Sem framer-motion de propósito:
// este componente precisa estar no bundle inicial e as landings públicas
// não podem pagar o custo do vendor-ui (meta Lighthouse mobile).
const PageLoader: React.FC<PageLoaderProps> = ({ variant = 'fullscreen' }) => {
  if (variant === 'inline') {
    return (
      <div className="p-8 flex justify-center">
        <div className="w-8 h-8 border-4 border-terra-500 border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  // dark:bg-ink-900 é obrigatório: .dark pode já estar no <html> antes do
  // conteúdo carregar, e a paleta escura da marca seria invisível sobre cream
  return (
    <div className="min-h-screen bg-cream-50 dark:bg-ink-900 flex items-center justify-center">
      <div className="text-center">
        <Logo variant="lockup-vertical" size={64} className="mb-4" />
        <div className="w-8 h-8 border-4 border-terra-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-ink-500 dark:text-ink-300">Carregando...</p>
      </div>
    </div>
  )
}

export default PageLoader
